import React from "react";
import { Button } from "antd";
import { styleConstants } from "../../constants";

const CommonButton = ({ text, buttonColor, style, ...buttonProps }) => {
  const bgColor = styleConstants.color[buttonColor] || undefined;

  const buttonColorStyles = {
    backgroundColor: bgColor,
    borderColor: bgColor
  };

  return (
    <Button style={{ ...buttonColorStyles, ...style }} {...buttonProps}>
      {text}
    </Button>
  );
};

export default CommonButton;
